// ===================== Icon Import ======================
import {
  FaHtml5,
  FaCss3,
  FaNodeJs,
  FaReact,
  FaFigma,
  FaBootstrap,
  FaMapMarkerAlt,
  FaDribbble,
  FaInstagram,
  FaLinkedin,
  FaNpm,
  FaGitAlt,
} from "react-icons/fa";
import {
  SiMongodb,
  SiExpress,
  SiRedux,
  SiHeroku,
  SiVisualstudiocode,
  SiGithub,
  SiFirebase,
  SiJsonwebtokens,
  SiVercel,
  SiGmail,
  SiWhatsapp,
} from "react-icons/si";
import { SiTailwindcss } from "react-icons/si";
import { TbApi } from "react-icons/tb";
import { BsMedium } from "react-icons/bs";
import { TbBrandJavascript } from "react-icons/tb";

// =========================== Projects Image ==========================
import project1 from "./assets/project1.png";
import project2 from "./assets/project2.png";
import project3 from "./assets/project3.png";
import project4 from "./assets/project4.png";
import project5 from "./assets/project5.png";
import project6 from "./assets/project6.png";
import project7 from "./assets/project7.png";
import project8 from "./assets/project8.png";
import project9 from "./assets/project9.png";
import project10 from "./assets/project10.png";
import project11 from "./assets/project11.png";
import project12 from "./assets/project12.png";

export const navLinks = ["home", "about", "skills", "portfolio", "contact"];

export const socialIcons = [
  <FaDribbble />,
  <FaInstagram />,
  <FaLinkedin />,
  <BsMedium />,
];

// ===================== Export Icons ===================
export const icons = [
  <FaHtml5 />,
  <FaCss3 />,
  <TbBrandJavascript />,
  <SiTailwindcss />,
  <FaBootstrap />,
  <FaReact />,
  <TbApi />,
  <SiRedux />,
  <FaNodeJs />,
  <FaNpm />,
  <SiMongodb />,
  <SiExpress />,
  <SiJsonwebtokens />,
  <FaFigma />,
  <SiHeroku />,
  <SiVercel />,
  <SiVisualstudiocode />,
  <FaGitAlt />,
  <SiGithub />,
  <SiFirebase />,
];

// ====================== Export Project Details ======================
export const workImages = [
  {
    id: 1,
    img: project12,
    name: "project 1",
    category: "react",
    live: "https://cryptosite-reactapp.netlify.app",
    code: "https://github.com/HossainRafi/CryptoSite.git",
  },
  {
    id: 2,
    img: project1,
    name: "project 2",
    category: "react",
    live: "https://shoe-house.netlify.app",
    code: "https://github.com/HossainRafi/ShoeHouse.git",
  },
  {
    id: 3,
    img: project2,
    name: "project 3",
    category: "javascript",
    live: "https://skycast-js.netlify.app",
    code: "https://github.com/HossainRafi/SkyCast.git",
  },
  {
    id: 4,
    img: project3,
    name: "project 4",
    category: "react",
    live: "https://foodking-ui.netlify.app",
    code: "https://github.com/HossainRafi/FoodKing.git",
  },
  {
    id: 5,
    img: project4,
    name: "project 5",
    category: "javascript",
    live: "https://filter-web.netlify.app",
    code: "https://github.com/HossainRafi/JSFilter.git",
  },
  {
    id: 6,
    img: project5,
    name: "project 6",
    category: "react",
    live: "https://reactrest-country.netlify.app",
    code: "https://github.com/HossainRafi/Countries.git",
  },
  {
    id: 7,
    img: project6,
    name: "project 7",
    category: "javascript",
    live: "https://js-quickquiz.netlify.app",
    code: "https://github.com/HossainRafi/JSQuiz.git",
  },

  {
    id: 8,
    img: project7,
    name: "project 8",
    category: "react",
    live: "https://colorpickereact.netlify.app",
    code: "https://github.com/HossainRafi/ColorPicker.git",
  },
  {
    id: 9,
    img: project8,
    name: "project 9",
    category: "javascript",
    live: "https://todo-with-js.netlify.app",
    code: "https://github.com/HossainRafi/JSToDo.git",
  },
  {
    id: 10,
    img: project9,
    name: "project 10",
    category: "react",
    live: "https://cryptoui.netlify.app",
    code: "https://github.com/HossainRafi/Crypto.git",
  },
  {
    id: 11,
    img: project10,
    name: "project 11",
    category: "javascript",
    live: "https://addcartjs.netlify.app",
    code: "https://github.com/HossainRafi/AddToCart.git",
  },
  {
    id: 12,
    img: project11,
    name: "project 12",
    category: "javascript",
    live: "https://currencyconverter-appjs.netlify.app",
    code: "https://github.com/HossainRafi/CurrencyConverter.git",
  },
];

export const workNavs = ["All", "JavaScript", "React"];

export const contacts = [
  {
    id: 1,
    icon: <FaMapMarkerAlt />,
    infoText: "Barishal, Bangladesh",
  },
  {
    id: 2,
    icon: <SiGmail />,
    infoText: "hossainrafi71@gmail.com",
  },
  {
    id: 3,
    icon: <SiWhatsapp />,
    infoText: "+8801623389795",
  },
];
